import React, { useContext, useEffect, useState } from "react";
import "./ProductDisplay.css";
import star_icon from "../Assets/star_icon.png";
import star_dull_icon from "../Assets/star_dull_icon.png";
import { ShopContext } from "../../Context/ShopContext";
import default_img from "../../Components/Assets/default_img.png";
import { callMultipleApis } from "../../services/ApiServices";


const mainURL = process.env.REACT_APP_API_BASE_URL;
const getUpdateProductViewCount = process.env.REACT_APP_UPDATE_PRODUCT_VIEW_COUNT_URL;

const ProductDisplay = (props) => {
  const { product, averageRating, totalReviews } = props;
  const { addToCart } = useContext(ShopContext);
  const filledStars = Math.round(averageRating);
  const [mainImage, setMainImage] = useState("");
  const [selectedVariant, setSelectedVariant] = useState(0);

  const [modalConfig, setModalConfig] = useState({ isOpen: false, url: "" });
  const openZoom = (url) => setModalConfig({ isOpen: true, url });

  useEffect(() => {

    const updateProductCount = async () => {
      try {
        if (!product?.item_id) return;
        if (product?.product_images?.length > 0) {
          const primaryImage = product?.product_images?.find(
            (img) => img.set_as_primary_image === 1
          );
          
          if (primaryImage == '' || primaryImage === undefined) {
            setMainImage(mainURL + "/" + product?.product_images[0]?.image_path);
          } else {
            setMainImage(mainURL + "/" + primaryImage.image_path);
          }

        }
        const data = {
          productid: product.item_id
        };

        await callMultipleApis([
          {
            url: getUpdateProductViewCount,
            method: "POST",
            data: data,
            params: {},
            headers: {},
          }
        ]);

      } catch (error) {
        //console.error("Error :", error);
      }
    };

    updateProductCount();
  }, [product]);

  //console.log("productdisplay", product);  

  return (
    <div className="amazon-product-page">

      {/* LEFT : Images */}

      <div className="amazon-left">

        <div className="image-section">

          <div className="thumb-list">
            {product.product_images?.map((img, index) => (
              <img
                key={index}
                src={img.image_path === "" ? default_img : mainURL + "/" + img.image_path}
                alt=""
                onClick={() =>
                  setMainImage(
                    img.image_path
                      ? mainURL + "/" + img.image_path
                      : default_img
                  )
                }
                className={
                  mainImage === mainURL + "/" + img.image_path
                    ? "active"
                    : ""
                }
              />
            ))}
          </div>

          <div className="main-image">
            <img src={mainImage || default_img} alt="product" />
          </div>

        </div>

        {/* VARIANTS MOVED HERE */}

        <div className="variant-section">

          <h3 className="variant-title">Available Variant</h3>

          <div className="variant-grid">

            {product.product_cost?.map((item, index) => (

              <div
                key={index}
                className={`variant-card ${selectedVariant === index ? "active" : ""}`}
                onClick={() => setSelectedVariant(index)}
              >

                <div className="variant-size">
                  Size {item.product_size}
                </div>

                {item.product_color && (
                  <div className="variant-color">
                    {item.product_color}
                  </div>
                )}

                <div className="variant-price">
                  ₹{item.selling_price}
                </div>

              </div>

            ))}

          </div>

        </div>

        <p className="category">
          Category : {product.category_name}
        </p>

      </div>


      {/* CENTER : Details */}
      <div className="amazon-center">

        <h1 className="product-title">{product.item_name}</h1>

        <div className="rating-row">
          {[...Array(5)].map((_, index) => (
            <img
              key={index}
              src={index < filledStars ? star_icon : star_dull_icon}
              alt=""
            />
          ))}
          <span className="review-count">{totalReviews} ratings</span>
        </div>

        <hr />

        <div
          className="product-description"
          dangerouslySetInnerHTML={{ __html: product.item_description }}
        />

      </div>


      {/* RIGHT : BUY BOX */}
      <div className="amazon-right">

        <div className="buy-box">

          <div className="price-box">
            {/* ₹{product.product_cost?.[0]?.selling_price} */}
            ₹{product.product_cost?.[selectedVariant]?.selling_price}
          </div>

          <div className="stock">In Stock</div>

          {/* Add to Cart - Always First */}
          {/* <button
            className="buy-btn buy-addtocart"
            onClick={() => addToCart(product.item_id)}
          >
            🛒 Add to Cart
          </button> */}

          {product.product_channels?.map((ch, index) => (
            <a
              key={index}
              href={ch.channel_url}
              target="_blank"
              rel="noopener noreferrer"
              className={`buy-btn buy-${ch.channel_name.toLowerCase()}`}
            >
              Buy on {ch.channel_name}
            </a>
          ))}

        </div>

      </div>

    </div>
  );
};

export default ProductDisplay;
